<template>
    <div class="portlet light borderless">
        <div class="portlet-title tabbable-line">
            <div class="caption">
                    <span class="caption-subject bold uppercase">
                        {{ item.name }} - <small> value list </small>
                    </span>
            </div>
            <div class="actions">
                <button v-if="item.slug == 'coduri_cor'" class="btn btn-xs btn-outline dark" @click="$modal.show('coduri-cor-modal')">
                    <i class="glyphicon glyphicon-import"></i> Reges Online COR Codes
                </button>
                <button v-if="item.slug == 'coduri_caen'" class="btn btn-xs btn-outline dark" @click="$modal.show('coduri-caen-modal')">
                    <i class="glyphicon glyphicon-import"></i> Reges Online CAEN Codes
                </button>
                <button class="btn btn-sm btn-outline dark" @click="newValue()">
                    <i class="glyphicon glyphicon-plus"></i> New Value
                </button>
            </div>
        </div>
        <div class="portlet-body">
            <table class="table">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Country</th>
                    <th>Valid from</th>
                    <th>Data</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, index) in item.values">
                    <td v-text="index + 1"></td>
                    <td v-text="value.country_code"></td>
                    <td v-text="value.valid_from"></td>
                    <td v-if="item.is_single_valued">
                        <div v-for="field in item.fields">
                            <label v-text="field.name"></label>: <span v-text="value['data'][field.slug]"></span>
                        </div>
                    </td>
                    <td v-else v-text="`${value.data.length} items`"></td>
                    <td>
                        <button class="btn btn-xs btn-outline dark" @click="edit(value)">
                            <i class="glyphicon glyphicon-pencil"></i>
                        </button>
                        <button class="btn btn-xs btn-outline red">
                            <i class="glyphicon glyphicon-trash"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <modal v-if="item.slug == 'coduri_cor'" name="coduri-cor-modal" :title="'How To Import Reges Online Cor Codes'">
                <div class="margin-top-40">
                    <div class="row">
                        <div class="col-md-12"><b>1. Se ruleaza cron-ul</b></div>
                        <div class="col-md-11 col-md-offset-1">
                            <code class="inline-block">
                                SINCRON_URL /crons/cron_revisal/import_coduri_cor_from_reges_online?id_route=xxx
                            </code>
                        </div>
                        <div class="col-md-12">
                            &nbsp; &nbsp; Parametrii optionali
                        </div>
                        <div class="col-md-11 col-md-offset-1">
                            <code class="inline-block">
                                &client_id=yyy<br />
                                &company_id=zzz
                            </code>
                        </div>
                        <div class="col-md-12"><b>2. Din instanta specificata in rezultatul cronului se exporta tabela in format .sql</b></div>
                        <div class="col-md-11 col-md-offset-1">
                            <code class="inline-block">
                                coduri_cor_reges_online
                            </code>
                        </div>
                        <div class="col-md-12"><b>3. Se importa tabela in format .sql salvat in DB-ul central</b></div>
                        <div class="col-md-12"><b>4. Se ruleaza</b></div>
                        <div class="col-md-12 text-center margin-top-30">
                            <button v-on:click="goToReprocessConfigCodes('cor')" class="btn btn-outline dark">
                                <i class="glyphicon glyphicon-refresh"></i> Reprocess Cor Codes from Reges Online
                            </button>
                        </div>
                    </div>
                </div>

                <div slot="actions">
                    <button v-on:click="goToReprocessConfigCodes('cor')" class="btn btn-outline dark">
                        <i class="glyphicon glyphicon-refresh"></i> Reprocess Cor Codes from Reges Online
                    </button>
                    <button class="btn btn-outline" @click="$modal.hide('coduri-cor-modal')">Close</button>
                </div>
            </modal>

            <modal v-if="item.slug == 'coduri_caen'" name="coduri-caen-modal" :title="'How To Import Reges Online CAEN Codes'">
                <div class="margin-top-40">
                    <div class="row">
                        <div class="col-md-12"><b>1. Se ruleaza cron-ul</b></div>
                        <div class="col-md-11 col-md-offset-1">
                            <code class="inline-block">
                                SINCRON_URL /crons/cron_revisal/import_coduri_caen_from_reges_online?id_route=xxx
                            </code>
                        </div>
                        <div class="col-md-12">
                            &nbsp; &nbsp; Parametrii optionali
                        </div>
                        <div class="col-md-11 col-md-offset-1">
                            <code class="inline-block">
                                &client_id=yyy<br />
                                &company_id=zzz
                            </code>
                        </div>
                        <div class="col-md-12"><b>2. Din instanta specificata in rezultatul cronului se exporta tabela in format .sql</b></div>
                        <div class="col-md-11 col-md-offset-1">
                            <code class="inline-block">
                                coduri_caen_reges_online
                            </code>
                        </div>
                        <div class="col-md-12"><b>3. Se importa tabela in format .sql salvat in DB-ul central</b></div>
                        <div class="col-md-12"><b>6. Se ruleaza</b></div>
                        <div class="col-md-12 text-center margin-top-30">
                            <button v-on:click="goToReprocessConfigCodes('caen')" class="btn btn-outline dark">
                                <i class="glyphicon glyphicon-refresh"></i> Reprocess Caen Codes from Reges Online
                            </button>
                        </div>
                    </div>
                </div>

                <div slot="actions">
                    <button v-on:click="goToReprocessConfigCodes('caen')" class="btn btn-outline dark">
                        <i class="glyphicon glyphicon-refresh"></i> Reprocess Caen Codes from Reges Online
                    </button>
                    <button class="btn btn-outline" @click="$modal.hide('coduri-caen-modal')">Close</button>
                </div>
            </modal>

        </div>
    </div>
</template>

<script>
    import Modal from 'components/global/Modal'

    export default {
        name: "config-item-value-list",

        components: {
            Modal
        },

        props: {
            item: {
                required: true,
                type: Object
            }
        },

        methods: {
            newValue() {
                this.$emit('new-value')
            },

            edit(value) {
                this.$emit('edit-value', {
                    value: value
                })
            },

            goToReprocessConfigCodes(source) {
                location.href = Sincron.routes.route('config.reprocess-config-codes', {source: source})
            }
        }
    }
</script>

<style scoped>

</style>